<template>
	<div class="wrapper-navi">
		<div class="multiply-bg"></div>
		<div class="multiply-content">
			<div class="row no-gutters">
				<div class="col order-1 col-md-auto order-md-1 align-self-center">
					<router-link :to="{ path: '/' }">
						<!-- <img class="app-logo" src="/static/img/logo-cshare.svg"> -->
						<img class="app-logo" :src="page.logo">
					</router-link>
				</div>
				<div class="col-12 order-4 col-md order-md-2 text-center">
					<div v-if="resNavigation" class="row no-gutters justify-content-center">
						<div class="col col-sm-auto pl-3">
							<router-link :to="{name: 'PagePlace', params: this.$route.params}" v-if="resStation">
								<div class="navi-progress navi-place text-center checked">
									<div class="nav-icn icn-location_dot"></div>
									<p>{{ resStation.name }} - {{ resStation.city }},<br>{{ resStation.street }}</p>
								</div>
							</router-link>
							<div v-else class="navi-progress navi-place text-center">
								<div class="nav-icn icn-location_dot"></div>
								<p>Start- und<br>Zielort</p>
							</div>
						</div>
						<div class="col col-sm-auto px-1">
							<router-link :to="{name: 'PageTime', params: this.$route.params}" v-if="resStartdate && resEnddate">
								<div class="navi-progress navi-time text-center checked">
									<div class="nav-icn icn-timer"></div>
									<p v-html="formatter.OUTPUT_DATE_RANGE(resStartdate, resEnddate)"></p>
								</div>
							</router-link>
							<div v-else class="navi-progress navi-time text-center">
								<div class="nav-icn icn-timer"></div>
								<p>Start- und<br>Zielzeit</p>
							</div>
						</div>
						<div class="col col-sm-auto pr-3">
							<router-link :to="{name: 'PageCar', params: this.$route.params}" v-if="resCar">
								<div class="navi-progress navi-car text-center checked">
									<div class="nav-icn icn-car"></div>
									<p>{{ resCar.app_description || resCar.title_web }}</p>
								</div>
							</router-link>
							<div v-else class="navi-progress navi-car text-center">
								<div class="nav-icn icn-car"></div>
								<p>Fahrzeug<br>Wahl</p>
							</div>
						</div>
					</div>
					<div v-else class="row no-gutters logoClaim">
						<div class="col col-sm-auto pl-3 align-self-center">
							<h3>|&nbsp;&nbsp;&nbsp;{{ page.claim }}</h3>
						</div>
					</div>
				</div>
				<div class="col-auto order-2 col-md-auto order-md-3 align-self-center">
					<router-link :to="{ name: 'PageLogin' }" v-if="!$store.getters['orm/reservation/user_session']" class="login-btn">
						<span>{{ $t('LOGIN_BAR.LOGIN_BAR.LOGIN') }}</span>
					</router-link>
				</div>
				<div class="col-auto order-3 col-md-auto order-md-4 align-self-center">
					<div class="menu-burger"

						v-on:click="showMenu = !showMenu"
					>
						<a id="burger" class="burger"><span>{{ $t('Menu') }}</span></a>
					</div>
				</div>


			</div>
		</div>

	<div class="navi-open "
	v-bind:class="{ active: showMenu }" >

		<div class="container-fluid">
			<div class="row align-items-center">
				<div class="col-sm-6 col-md-5 col-lg-4 col-xl-3 align-self-center" style="margin: 0 auto;">
					<ul v-if="!mainnavigation" >
						<li v-if="!$store.getters['orm/reservation/user_session']">
							<router-link :to="{name: 'PageLogin'}"  @click.native="showMenu = !showMenu">
								<i class="icn icn-nav icn-key"></i> {{ $t('LOGIN_BAR.LOGIN_BAR.LOGIN') }}
							</router-link> / <router-link :to="{name: 'PageRegister'}"  @click.native="showMenu = !showMenu">Registrieren</router-link>
						</li>
						<li v-else>
							<router-link :to="{name: 'PageMycshare'}" @click.native="showMenu = !showMenu"><i class="fa fa-id-card"></i> Mein C-Share</router-link>
						</li>
						<li>
							<router-link :to="{name: 'PagePlace'}" @click.native="showMenu = !showMenu"><i class="fa fa-car"></i> Fahrzeug reservieren</router-link>
						</li>
						<li>
							<router-link :to="{name: 'PageFaq'}" @click.native="showMenu = !showMenu"><i class="fa fa-book"></i> Anleitung / FAQ</router-link>
						</li>
						<li>
							<router-link :to="{name: 'PageContact'}" @click.native="showMenu = !showMenu"><i class="fa fa-phone"></i> Kontakt / Hotline</router-link>
						</li>
						<li v-if="!!$store.getters['orm/reservation/user_session']">
							<a href="#" @click="processLogout"><i class="fa fa-key"></i> {{ $t('LOGIN_BAR.LOGIN_BAR.LOGOUT') }}</a>
						</li>
						<li v-if="$store.getters['orm/reservation/user_session']">
								<router-link :to="{name: 'PageMycshare'}" @click.native="showMenu = !showMenu"><i class="fa fa-id-card"></i> Mein C-Share</router-link>
						</li>
					</ul>
					<ul v-else>
						<li v-for="(item, index) in mainnavigation" :key="item.path" v-if="!$store.getters['orm/reservation/user_session'] && item.type == 'modular/doubleinternal'">
								<router-link :to="{name: item.path}" @click.native="showMenu = !showMenu">
					    			<i class="icn icn-nav" v-bind:class="item.icon"></i>
					    			<div class="nav-text">{{ $t(item.name) }}</div>
					    		</router-link> / <router-link :to="{name: item.path2}"  @click.native="showMenu = !showMenu">
					    			{{ $t(item.name2) }}
					    		</router-link>
						</li>
						<li v-if="$store.getters['orm/reservation/user_session']">
							<router-link :to="{name: 'PageMycshare'}" @click.native="showMenu = !showMenu"><i class="icn icn-nav icn-person"></i>
								<div class="nav-text">Mein C-Share</div>
							</router-link>
						</li>
						<li v-for="(item, index) in mainnavigation" :key="item.path" v-if="item.type != 'modular/doubleinternal'">
							<router-link :to="{name: item.path}"  @click.native="showMenu = !showMenu" v-if="item.type == 'modular/internal'">
					    		<i class="icn icn-nav" v-bind:class="item.icon"></i>
					    		<div class="nav-text">{{ $t(item.name) }}</div>
					    	</router-link>
					    	<span  v-if="item.type == 'modular/doubleinternal'">
					    		<router-link :to="{name: item.path}" @click.native="showMenu = !showMenu">
					    		<i class="icn icn-nav" v-bind:class="item.icon"></i>
					    		<div class="nav-text">{{ $t(item.name) }}</div>
					    		</router-link>/ <router-link :to="{name: item.path2}"  @click.native="showMenu = !showMenu">{{ $t(item.name2) }}</router-link>
					    	</span>
							<router-link :to="{ name: 'Page', params: {id: item.path, type: 'main' } }"  v-if="item.type == 'modular/page'" @click.native="showMenu = !showMenu">
				    			<i class="icn icn-nav" v-bind:class="item.icon"></i>
				    			<div class="nav-text">{{ $t(item.name) }}</div>
				    		</router-link>

							<a :href="getApiLink(item.path)" class="nav-link" v-if="item.type == 'modular/external'">{{ $t(item.name) }}</a>
						</li>
						<li v-if="$store.getters['orm/reservation/user_session']">
							<a href="#" @click="processLogout">
								<i class="icn icn-nav icn-key"></i>
								<div class="nav-text">{{ $t('LOGIN_BAR.LOGIN_BAR.LOGOUT') }}</div>
							</a>
						</li>

					</ul>
				</div>
			</div>
		</div>
		<div class="bg-blue-multiply navi-open-bg"></div>
	</div>
</div>
</template>


<script>
import { mapGetters } from 'vuex'
import formatter 		from '@/store/orm/helpers/formater';

export default {
	name: "Navigation",

	data() {
		return{
			page: {},
			showMenu: false,
			formatter,
			mainnavigation: this.$store.getters['orm/mainnavigationAll']
		};

	},
	computed: {
	    ...mapGetters('orm/reservation', {
	    	resStation: 'station',
			resStartdate: 'startdate',
			resEnddate: 'enddate',
			resCar: 'car',
			resNavigation: 'navigation',

	    }),

	},
	props: {
		tocheck: {
			type: Array,
			default(){
				return [];
			}
		},
		reservationSteps: {
	      type: Boolean,
	      default: false
	    }
	},
	mounted(){
		var self = this;
		this.$store.dispatch('orm/GET_HEADERNAVIGATION')
			.then(result => {
				console.log('GET_HEADERNAVIGATION Seite', result)
				self.page = result
			}).catch(err => { this.$store.commit("core/ADD_ERROR", err); })
	    	console.log(self.page);
	},
	methods: {

		processLogout() {
			var self = this;
			this.$store.dispatch('orm/LOGOUT_CUSTOMER')
			.then(res => {
				self.showMenu = !self.showMenu
				self.$router.push({ path: '/' })
			});

		}
	}
}
</script>







// WEBPACK FOOTER //
// src/components/Generals/Navigation.vue